import React from 'react';
import PropTypes from 'prop-types';
import { DefaultOverlay, HoverOverlay } from './overlays';

const ImageOverlay = props => {
  const { defaultOverlayProps, hoverOverlayProps, isHoverActive, showTileMetadataOnHover } = props;

  if (isHoverActive && showTileMetadataOnHover) return <HoverOverlay {...hoverOverlayProps} />;
  return <DefaultOverlay {...defaultOverlayProps} />;
};

export default ImageOverlay;

ImageOverlay.propTypes = {
  defaultOverlayProps: PropTypes.shape({}).isRequired,
  hoverOverlayProps: PropTypes.shape({}).isRequired,
  isHoverActive: PropTypes.bool.isRequired,
  showTileMetadataOnHover: PropTypes.bool.isRequired,
};
